class BESSAppAPIServiceBase extends BESSAppBase {

    static statusOK = 'OK';

    constructor(parent, apiBase) {
        super();
        this.parent = parent;
        this.context = {};
        if (parent === null) {
            this.csrfToken = $('input[name="csrfmiddlewaretoken"]').val();
            this.caller = new BESSAppAPICaller(this, apiBase, this.csrfToken);
        } else {
            this.csrfToken = parent.csrfToken;
            this.caller = new BESSAppAPICaller(this, parent.caller.apiBase + apiBase, this.csrfToken);
        }
        //this.log("API Base: " + this.caller.apiBase);
    }

    _addContext(options) {
        if (this.parent != null) {
            this.parent._addContext(options);
        }
        if (options.data !== undefined) {
            options.data = _.merge(options.data, this.context);
        }
    }

    _post(path, options) {
        this._addContext(options);
        options.handler = this.#decorateHandler(options);
        this.caller.post(path, options);
    }

    _get(path, options) {
        this._addContext(options);
        options.handler = this.#decorateHandler(options);
        this.caller.get(path, options);
    }

    #decorateHandler(options) {
        let onResult = options.onResult;
        options.onResult = function (data) {
            if (data.status === BESSAppAPIServiceBase.statusOK) {
                if (onResult != null) {
                    onResult(data.result);
                }
            } else {
                this._onError(data);
            }
        }.bind(this);

        options.onError = this._onError.bind(this);
        return options;
    }

    _onError(data) {
    }
}

class BESSAppAPIService extends BESSAppAPIServiceBase {

    constructor() {
        super(null, '/app/api/');
        this.project = new BESSAppProjectAPIService(this);
        this.projects = new BESSAppProjectsAPIService(this);
        this.session = new BESSAppSessionAPIService(this);
        this.auth = new BESSAppAuthAPIService(this);
        this.council = new BESSAppCouncilAPIService(this);
    }

    sendContact(contactFormData, handler) {
        this._post('contact', {
            formData: contactFormData,
            onResult: handler
        });
    }

    search(searchTerm, handler) {
        this._post('search', {
            data: {
                'search': searchTerm,
            },
            onResult: handler,
        })
    }
}